import TheGrid from '@/views/campaigns/bestof/resultsdsr/grid'

export default {
  path: '/campaigns/bestof/dsr-results',
  redirect: '/campaigns/bestof/dsr-results/index',
  name: 'bestof_resultsdsr',
  meta: {
    auth: {
      redirect: {
        name: 'bestof_resultsdsr.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestof'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bestof_resultsdsr.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
